import React from "react";
import { PiCertificate, PiSealCheck } from "react-icons/pi";

import { useGetCreditsAvailable } from "../../api/payments";
import useBOMUsage from "./useBOMUsage";

function LimitReachedMessage() {
  return <p className="bg-light rounded m-0 py-1 px-2">Great Job! Click upgrade to purchase more BOMs.</p>;
}

function BOMCounter() {
  const { data: creditsAvailable } = useGetCreditsAvailable();
  const qualCreditsAvailable = creditsAvailable?.qualCredits || 0;
  const certCreditsAvailable = creditsAvailable?.certCredits || 0;

  return (
    <div>
      <p className="m-0 mb-1 text-primary fw-bold" title={`${qualCreditsAvailable} Qualification Credits and ${certCreditsAvailable} Certification Credits Available`}>
        {qualCreditsAvailable} <PiSealCheck size={20} /> / {certCreditsAvailable} <PiCertificate size={20} />
      </p>
    </div>
  );
}

function BOMUsage() {
  const { maxReached } = useBOMUsage();

  return maxReached ? <LimitReachedMessage /> : <BOMCounter />;
}

export default BOMUsage;
